import { CAMPAIGN_BY_ID_API_TYPE } from 'helpers/sf_constants';
import _ from 'lodash';
import {
  CREATE_NEW_CAMPAIGN,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_AD_ERROR,
  DELETE_CAMPAIGN_AD_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN_SUCCESS,
  DUPLICATE_ADGROUP,
  DUPLICATE_ADGROUP_ERROR,
  DUPLICATE_ADGROUP_SUCCESS,
  DUPLICATE_CAMPAIGN,
  DUPLICATE_CAMPAIGN_ERROR,
  DUPLICATE_CAMPAIGN_SUCCESS,
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_ERROR,
  GET_CAMPAIGNS_SUCCESS,
  GET_CAMPAIGN_BY_ID,
  GET_CAMPAIGN_BY_ID_ERROR,
  GET_CAMPAIGN_BY_ID_SUCCESS,
  MODIFY_ADGROUP,
  MODIFY_ADGROUP_ERROR,
  MODIFY_ADGROUP_SUCCESS,
  MODIFY_CAMPAIGN,
  MODIFY_CAMPAIGN_ERROR,
  MODIFY_CAMPAIGN_SUCCESS,
  NEW_ADGROUP,
  NEW_ADGROUP_ERROR,
  NEW_ADGROUP_SUCCESS,
  NEW_CAMPAIGN_AD_ERROR,
  NEW_CAMPAIGN_AD_SUCCESS,
  NEW_CAMPAIGN_ERROR,
  NEW_CAMPAIGN_SUCCESS,
  RESET_LAST_COMPLETED_ACTION,
  NEW_ADGROUP_TRACKING,
  NEW_ADGROUP_TRACKING_SUCCESS,
  NEW_ADGROUP_TRACKING_ERROR,
  MODIFY_CAMPAIGN_AD_SUCCESS,
  MODIFY_CAMPAIGN_AD_ERROR,
  DELETE_ADGROUP,
  DELETE_ADGROUP_SUCCESS,
  DELETE_ADGROUP_ERROR,
  DELETE_MULTIPLE_CAMPAIGN,
  DELETE_MULTIPLE_CAMPAIGN_SUCCESS,
  DELETE_MULTIPLE_CAMPAIGN_ERROR,
  RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS,
  GET_ACCOUNT_CAMPAIGNS,
  GET_ACCOUNT_CAMPAIGNS_SUCCESS,
  GET_ACCOUNT_CAMPAIGNS_ERROR,
  GET_FILTER_VOLUME,
  GET_FILTER_VOLUME_SUCCESS,
  GET_FILTER_VOLUME_ERROR,
  GET_CLICK_CAMPAIGN_STATS,
  GET_CLICK_CAMPAIGN_STATS_SUCCESS,
  GET_CLICK_CAMPAIGN_STATS_ERROR,
  GET_CLICK_CAMPAIGN_STATS_BY_ID,
  GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR,
  GET_LEAD_CAMPAIGN_STATS,
  GET_LEAD_CAMPAIGN_STATS_SUCCESS,
  GET_CALL_CAMPAIGN_STATS_SUCCESS,
  GET_CALL_CAMPAIGN_STATS,
  GET_CALL_CAMPAIGN_STATS_ERROR,
  GET_LEAD_CAMPAIGN_STATS_ERROR,
  GET_LEAD_CAMPAIGN_STATS_BY_ID,
  GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR,
  GET_CALL_CAMPAIGN_STATS_BY_ID,
  GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR,
  NEW_CAMPAIGN_AD,
  GET_FILTER_PACKAGES,
  GET_FILTER_PACKAGES_SUCCESS,
  GET_FILTER_PACKAGES_ERROR,
  GET_CAMPAIGNS_SOURCE_SETTINGS,
  GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS,
  GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR,
  GET_BID_MULTIPLIER_HISTORY,
  GET_BID_MULTIPLIER_HISTORY_SUCCESS,
  GET_BID_MULTIPLIER_HISTORY_ERROR,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR,
  GET_DEFAULT_TRANSFER_NUMBER,
  GET_DEFAULT_TRANSFER_NUMBER_SUCCESS,
  GET_DEFAULT_TRANSFER_NUMBER_ERROR,
  SET_PREVIOUS_LEAD_TYPE_ID,
  GET_AD_GROUP_STATS_V4,
  GET_AD_GROUP_STATS_V4_SUCCESS,
  GET_AD_GROUP_STATS_V4_ERROR,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR,
} from './actionTypes';
import { DATE_RANGE_OPTIONS } from 'components/Common/DateRangePicker';


const constructAdgroupWithLastPrice = (ad_group, payload) => {

  let last_price = null;
  if (!ad_group?.base_bid_price || ad_group?.base_bid_price.toString() !== payload?.base_bid_price.toString()) {

    last_price = ad_group.base_bid_price;
  }
  const updatedAdGroup = { ...ad_group, ..._.pick(payload, PROPERTIES_TO_PICK_MODIFY_AD_GROUP), 'last_bid_price': last_price }
  return updatedAdGroup;
}
const constructSourceSettingsWithLastPrice = (source_setting, payload) => {
  let last_price = source_setting?.last_weight || null
  if (!source_setting?.weight || source_setting?.weight.toString() !== payload?.weight.toString()) {
    last_price = source_setting?.weight;
  }
  const updatedAdGroup = { ...source_setting, ..._.pick(payload, PROPERTIES_TO_PICK_MODIFY_CAMPAIGN_SOURCE_SETTING), 'last_weight': last_price }
  return updatedAdGroup;
}

const initialState = {
  campaigns: [],
  bid_multiplier_history: [],
  bid_multiplier_history_loading: false,
  ad_group_bid_multiplier_history: [],
  ad_group_bid_multiplier_history_loading: false,
  ad_group_bid_multiplier_history_error: null,
  user: {},
  error: null,
  loading: false,
  modify_campaign_loading: false,
  modify_adgroup_loading: false,
  volume_forecast_loading: false,
  lastCampaignId: '',
  lastCompletedAction: null,
  // just save the last fetched timeframe
  // if Last Month campaigns data was fetched last time,
  // this state would store "LAST_MONTH". Now if we land on
  // the campaigns index page from some other page, it would go to
  // "ALL_TIME" and we have to call the get campaigns API again.
  last_fetch_all_campaigns_time_frame_key: null,
  // the time frame key above cannot tell two custom ranges apart — every custom range
  // carries the same "Custom Range" key — so the dates of the range we last requested
  // are kept here too. Any caller (App.js on brand/timezone load, the campaigns pages)
  // can then tell whether the campaigns already in the store are for the range it needs
  // instead of re-requesting the same data. Null for non-custom ranges, where the key
  // alone is enough. (BM-9197)
  last_fetch_all_campaigns_custom_date_range: null,
  // which request failed, as `{ time_frame_key, start_date, end_date }`. A failure has to be
  // attributable: `App.js` and the campaigns pages can be asking for different ranges at the same
  // time, so a caller must be able to tell whether the request that failed was its own before it
  // decides to hold off on retrying. Cleared as soon as another request starts. (BM-9197)
  last_failed_all_campaigns_fetch: null,
  // same thing as above, but this just store it as an object
  // for each of the campaign fetched by id
  last_fetch_campaigns_by_id_previous_time_frame_key: {},
  click_campaign_stats: [],
  lead_campaign_stats: [],
  call_campaign_stats: [],
  last_fetch_all_cmps_stats_time_key: null,
  last_fetch_all_cmps_stats_custom_date_range: null,
  last_fetch_cmps_stats_by_id_time_key: {},
  loading_all_cmps_stats: false,
  loading_all_cmps_lead_stats: false,
  loading_all_cmps_call_stats: false,
  loading_cmps_stats_by_id: false,
  loading_cmps_lead_stats_by_id: false,
  loading_cmps_call_stats_by_id: false,
  click_campaign_stats_loading: false,
  call_campaign_stats_loading: false,
  lead_campaign_stats_loading: false,
  lastAdGroupId: null,
  copy_schedule_to_all_campaign: false,
  account_campaigns: [],
  account_campaigns_loading: false,
  account_campaigns_error: false,
  loading_campaigns_by_id: false,
  filterVolumeData: {},
  filter_packages: [],
  loading_filter_packages: null,
  filter_packages_error: null,
  // this is for show active campaings
  active_campaigns_for_sources: [],
  active_campaigns_for_sources_loading: false,
  default_transfer_number: null,
  default_transfer_number_loading: false,
  default_transfer_number_error: null,
  previous_lead_type_id: null,
  ad_group_stats_v4: [],
  ad_group_stats_v4_loading: false,
  ad_group_stats_v4_error: null,
};

const PROPERTIES_TO_PICK_MODIFY_CAMPAIGN = [
  "id",
  "account_id",
  "user_id",
  "created_at",
  "updated_at",
  "lead_type_id",
  "product_type_id",
  "name",
  "active",
  "monthly_budget",
  "monthly_volume",
  "is_campaign_level_tracking",
  "brand_id",
  "timezone",
  "discarded_at",
  "price_presentation",
  "lead_integrations",
  "locked_price",
  "price",
  "last_transaction",
  "campaign_budgets",
  "campaign_bid_modifier_groups",
  "campaign_filter_package",
  "campaign_filter_groups",
  "campaign_schedules",
  "campaign_quote_funnel",
  "campaign_ads",
  "click_campaign_setting",
  "call_campaign_setting",
  "lead_campaign_setting",
  "qf_lead_integrations",
  "qf_call_integrations",
  "qf_lead_setting",
  "qf_call_setting",
  "min_price",
  "max_price",
  "ad_groups",
  "allowable_return_perc",
  "shared_lead_type",
  "carrier_id"
]

const PROPERTIES_TO_PICK_MODIFY_AD_GROUP = [
  "id",
  "campaign_id",
  "created_at",
  "updated_at",
  "account_id",
  "base_bid_price",
  "ad_group_name",
  "active",
  "default_state",
  "discarded_at",
  "ad_group_filter_groups",
  "click_ad_group_setting",
  "call_ad_group_setting",
  "rtb_cm",
  "has_bid_history",
]

const PROPERTIES_TO_PICK_MODIFY_CAMPAIGN_SOURCE_SETTING = [
  "id",
  "source_type_id",
  "weight",
  "active",
  "source_type",
  "has_bid_history",
]

const PROPERTIES_TO_OMIT_GET_CAMPAIGN_BY_ID = [
  "ad_groups",
  "campaign_source_settings",
  "click_analytic_impressions",
  "click_analytic_searches",
  "click_analytic_clicks",
  "click_analytic_total_payout",
  "click_analytic_avg_position",
  "click_analytic_avg_bid",
  "click_analytic_ctr",
  "click_analytic_cpc",
  "locked_price",
  "min_price",
  "max_price"
]

const PROPERTIES_TO_PICK_CAMPAIGN_ANALYTICS = [
  "click_analytic_impressions",
  "click_analytic_searches",
  "click_analytic_clicks",
  "click_analytic_total_payout",
  "click_analytic_avg_position",
  "click_analytic_avg_bid",
  "click_analytic_ctr",
  "click_analytic_cpc"
]

const PROPERTIES_TO_PICK_AD_GROUPS = [
  "ad_groups"
]

const PROPERTIES_TO_PICK_CAMPAIGN_SOURCE_SETTING = [
  "campaign_source_settings"
]

const campaigns = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS:
      return {
        ...state,
        loading: true,
        last_fetch_all_campaigns_time_frame_key: action.payload.time_frame_key,
        // `fetched_range` is sent by callers that gate start_date/end_date behind
        // SF_FEATURE_FLAG_INCLUDE_DISCARDED_CAMPAIGNS, so the range being viewed is
        // recorded even when it is not part of the query. Callers that always send the
        // dates fall back to the query params themselves. (BM-9197)
        last_fetch_all_campaigns_custom_date_range: action.payload.time_frame_key === DATE_RANGE_OPTIONS.CUSTOM_RANGE
          ? (action.payload.fetched_range || action.payload.queryParams || null)
          : null,
        // a new request supersedes whatever failed before it
        last_failed_all_campaigns_fetch: null,
      };
    case GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaigns: action.payload.map(payload_cmp => ({ ...state.campaigns.find(cmp => cmp.id == payload_cmp.id), ...payload_cmp })),
        loading: false,
        last_fetch_all_campaigns_time_frame_key: action.time_frame_key,
      };

    case GET_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        // the request recorded its range on GET_CAMPAIGNS, before knowing whether it would
        // succeed. Leaving that in place would make the campaigns pages treat the range as
        // fetched and show stale or empty data without ever retrying, so drop it. What failed
        // is recorded instead, so a caller only holds off on retrying its own failure and not
        // somebody else's. (BM-9197)
        last_fetch_all_campaigns_time_frame_key: null,
        last_fetch_all_campaigns_custom_date_range: null,
        last_failed_all_campaigns_fetch: action.failed_request || null,
      };

    case GET_CAMPAIGN_BY_ID:
      return {
        ...state,
        loading_campaigns_by_id: true,
      };

    case GET_CAMPAIGN_BY_ID_SUCCESS:
      {
        const cmp_id = action.payload.id
        const cmp_index = state.campaigns.findIndex(campaign => campaign.id == cmp_id)
        let campaigns = _.cloneDeep(state.campaigns)
        if (cmp_index == -1) {
          campaigns.push(action.payload)
        } else {
          campaigns[cmp_index] = { ...campaigns[cmp_index], ...action.payload }
        }

        return {
          ...state,
          campaigns: campaigns,
          loading_campaigns_by_id: false,
          last_fetch_campaigns_by_id_previous_time_frame_key: {
            ...state.last_fetch_campaigns_by_id_previous_time_frame_key,
            [action.payload.id.toString()]: action.time_frame_key,
          },
        };
      }

    case GET_CAMPAIGN_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_campaigns_by_id: false,

      };
    case CREATE_NEW_CAMPAIGN:
      return {
        ...state,
        loading: true,
        copy_schedule_to_all_campaign: action.payload.copy_schedule_to_ui,
      };
    case DUPLICATE_CAMPAIGN:
      return {
        ...state,
        loading: true,
      };
    case DUPLICATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaigns: [...state.campaigns, action.payload],
        lastCampaignId: action.payload.id,
        loading: false,
        lastCompletedAction: action.type,

      };
    case DUPLICATE_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
      };

    case NEW_ADGROUP: return {
      ...state,
      loading: true,
      lastCompletedAction: action.type,
      lastAdGroupId: null,
    };

    case NEW_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaigns: [...state.campaigns, action.payload],
        lastCampaignId: action.payload.id,
        loading: false,
        error: null,
        lastCompletedAction: action.type,
      };

    case NEW_CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.payload,
        lastCampaignId: '',
        loading: false,
        lastCompletedAction: action.type,
      };

    case MODIFY_CAMPAIGN:
      return {
        ...state,
        modify_campaign_loading: true,
        copy_schedule_to_all_campaign: action.payload.copy_schedule_to_ui,
        error: null,
      };

    // before  // campaign.id.toString() === action.payload.id.toString()
    // after  // campaign.id == action.payload.id
    case MODIFY_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns?.map((campaign) => {
          if (campaign.id != action.payload.id) {
            return campaign;
          }

          const payload_source_settings = action.payload.campaign_source_settings
          return {
            ...campaign,
            ..._.pick(action.payload, PROPERTIES_TO_PICK_MODIFY_CAMPAIGN),
            campaign_source_settings: campaign.campaign_source_settings?.map(src_setting => {
              const payload_src_setting = payload_source_settings.find(payload_src_setting => payload_src_setting.id == src_setting.id)
              if (!payload_src_setting) {
                return src_setting;
              }
              const updatedSourceSetting = constructSourceSettingsWithLastPrice(src_setting, payload_src_setting);
              return {
                ..._.pick(payload_src_setting, PROPERTIES_TO_PICK_MODIFY_CAMPAIGN_SOURCE_SETTING),
                ...updatedSourceSetting
              }
            })
          }
        }),
        lastCampaignId: action.payload.id,
        modify_campaign_loading: false,
        lastCompletedAction: action.type,
        error: null,
      };

    case MODIFY_CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.payload,
        modify_campaign_loading: false,
        lastCompletedAction: action.type,
      };
    case DELETE_CAMPAIGN:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case DELETE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.filter(
          (campaign) => campaign.id.toString() !== action.payload.id.toString(),
        ),
        loading: false,
        error: null,
      };

    case DELETE_CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case DELETE_MULTIPLE_CAMPAIGN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_MULTIPLE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.filter(campaign => {
          return !action.payload.find(payload_campaign => payload_campaign.id === campaign.id)
        }),
        loading: false,
        error: null,
      };

    case DELETE_MULTIPLE_CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case NEW_ADGROUP_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload.campaign_id
          ? { ...campaign, ad_groups: [...campaign.ad_groups, action.payload] }
          : campaign)),
        loading: false,
        error: null,
        lastAdGroupId: action.payload.id,
        lastCompletedAction: action.type,
      };

    case NEW_ADGROUP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        lastCompletedAction: action.type,
      };

    case MODIFY_ADGROUP:
      return {
        ...state,
        modify_adgroup_loading: true,
        error: null,
      };

    case MODIFY_ADGROUP_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => {
          if (campaign.id !== action.payload.campaign_id) {
            return campaign;
          }
          const additional_data = action?.additional_data;
          const rtb_cm_settings_updated_adgroups = additional_data?.rtb_cm_settings_updated_adgroups
          let newAdgroups = campaign.ad_groups.map((ad_group) => ((ad_group.id == action.payload.id) ? constructAdgroupWithLastPrice(ad_group, action.payload) : ad_group));

          newAdgroups = newAdgroups?.map((ad_group) => {
            const updatedAdgroup = rtb_cm_settings_updated_adgroups.find(item => item.id === ad_group.id);
            if (updatedAdgroup) {
              return {
                ...ad_group,
                rtb_cm: updatedAdgroup.rtb_cm
              };
            } else {
              return ad_group;
            }
          });

          campaign.ad_groups = newAdgroups;
          return campaign;
        }),
        modify_adgroup_loading: false,
        error: null,
      };

    case MODIFY_ADGROUP_ERROR:
      return {
        ...state,
        error: action.payload,
        modify_adgroup_loading: false,
      };
    case DUPLICATE_ADGROUP:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ADGROUP:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ADGROUP_SUCCESS:
      const cmpgn = state.campaigns.find((ele) => ele.id === action.payload.campaign_id);
      let adgroups = cmpgn.ad_groups;
      adgroups = adgroups.filter((e) => e.id != action.payload.id);
      cmpgn.ad_groups = adgroups;
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload.campaign_id
          ? cmpgn
          : campaign)),
        loading: false,
        error: null,
      };

    case DELETE_ADGROUP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DUPLICATE_ADGROUP_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload.campaign_id
          ? { ...campaign, ad_groups: [...campaign.ad_groups, action.payload] }
          : campaign)),
        loading: false,
        error: null,
        lastCompletedAction: action.type,
      };

    case DUPLICATE_ADGROUP_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case RESET_LAST_COMPLETED_ACTION:
      return {
        ...state,
        lastCompletedAction: null,
        error: null,
      };

    case NEW_CAMPAIGN_AD:
      return {
        ...state,
        modify_campaign_loading: true,
      };

    case NEW_CAMPAIGN_AD_SUCCESS:
      return {
        ...state,
        // XXX: this assumes that the ads are always linked to a single campaign at once
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload[0]?.campaign_id
          ? { ...campaign, campaign_ads: [...campaign.campaign_ads, ...action.payload] }
          : campaign)),
        lastCompletedAction: action.type,
        error: null,
        modify_campaign_loading: false,
      };
    case NEW_CAMPAIGN_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        lastCompletedAction: action.type,
        modify_campaign_loading: false,
      };

    case DELETE_CAMPAIGN_AD_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload.campaign_id
          ? { ...campaign, campaign_ads: campaign.campaign_ads.filter((ca) => ca.id !== action.payload.id) }
          : campaign)),
        loading: false,
        error: null,
        lastCompletedAction: action.type,
      };

    case MODIFY_CAMPAIGN_AD_SUCCESS:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) => (campaign.id == action.payload.campaign_id
          ? ({ ...campaign, campaign_ads: campaign.campaign_ads.map((ca) => (ca.id === action.payload.id ? { ...action.payload } : ca)) })
          : campaign)),
        lastCompletedAction: action.type,
        error: null,
      };

    case MODIFY_CAMPAIGN_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        lastCompletedAction: action.type,
      };

    case DELETE_CAMPAIGN_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case NEW_ADGROUP_TRACKING:
      return {
        ...state,
        error: null,
      };
    case NEW_ADGROUP_TRACKING_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case NEW_ADGROUP_TRACKING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS:
      return {
        ...state,
        copy_schedule_to_all_campaign: false
      };

    case GET_ACCOUNT_CAMPAIGNS:
      return {
        ...state,
        account_campaigns_loading: true,
      };
    case GET_ACCOUNT_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        account_campaigns: action.payload,
        account_campaigns_loading: false,
      };

    case GET_ACCOUNT_CAMPAIGNS_ERROR:
      return {
        ...state,
        account_campaigns_error: action.payload,
        account_campaigns_loading: false,
      };

    case GET_FILTER_VOLUME:
      return {
        ...state,
        volume_forecast_loading: true
      };

    case GET_FILTER_VOLUME_SUCCESS:
      return {
        ...state,
        filterVolumeData: action.payload,
        volume_forecast_loading: false
      }
    case GET_FILTER_VOLUME_ERROR:
      return {
        ...state,
        error: action.payload,
        volume_forecast_loading: false
      }

    case GET_CLICK_CAMPAIGN_STATS:
      return {
        ...state,
        loading_all_cmps_stats: true,
        click_campaign_stats_loading: true,
        last_fetch_all_cmps_stats_time_key: action.payload.time_frame_key,
        last_fetch_all_cmps_stats_custom_date_range: action.payload.time_frame_key === DATE_RANGE_OPTIONS.CUSTOM_RANGE ? action.payload.queryParams : null,
      };

    case GET_CLICK_CAMPAIGN_STATS_SUCCESS:
      let click_cmp_stats = _.cloneDeep(state.click_campaign_stats);
      const updatedClickStats = action.payload.map(cmp_stat => {
        const cmp_index = click_cmp_stats.findIndex(click_cmp_stat => click_cmp_stat.id == cmp_stat.id)
        if (cmp_index == -1) {
          return cmp_stat;
        } else {
          return cmp_stat = _.merge(click_cmp_stats[cmp_index], cmp_stat);
        }
      })
      return {
        ...state,
        click_campaign_stats: updatedClickStats,
        last_fetch_all_cmps_stats_time_key: action.time_frame_key,
        loading_all_cmps_stats: false,
        click_campaign_stats_loading: false,
      };

    case GET_CLICK_CAMPAIGN_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loading_all_cmps_stats: false,
        click_campaign_stats_loading: false,
      };

    case GET_CLICK_CAMPAIGN_STATS_BY_ID:
      return {
        ...state,
        loading_cmps_stats_by_id: true,
      };

    case GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS:
      {
        let fetch_ad_groups = true;
        let fetch_source_settings = true;
        let fetch_campaign_stats = true;
        if (action.feature_flag) {
          fetch_ad_groups = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS];
          fetch_source_settings = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_SOURCE_SETTINGS];
          fetch_campaign_stats = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS];
        }
        const cmp_id = action.payload.id

        let fetch_time_obj_for_cmp = (state.last_fetch_cmps_stats_by_id_time_key[cmp_id.toString()] || {})
        if (fetch_ad_groups) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS] = action.time_frame_key
        }
        if (fetch_source_settings) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_SOURCE_SETTINGS] = action.time_frame_key
        }
        if (fetch_campaign_stats) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS] = action.time_frame_key
        }

        const cmp_index = state.click_campaign_stats.findIndex(campaign_stat => campaign_stat.id == action.payload.id)
        let click_cmp_stats = _.cloneDeep(state.click_campaign_stats)
        if (cmp_index == -1) {
          click_cmp_stats.push(action.payload)
        } else {
          if (action?.payload?.campaign_source_settings?.length === 0) {
            click_cmp_stats[cmp_index] = action.payload
          } else {
            click_cmp_stats[cmp_index] = _.merge(click_cmp_stats[cmp_index], action.payload)
          }
        }

        return {
          ...state,
          click_campaign_stats: click_cmp_stats,
          loading_cmps_stats_by_id: false,
          last_fetch_cmps_stats_by_id_time_key: {
            ...state.last_fetch_cmps_stats_by_id_time_key,
            [action.payload.id.toString()]: fetch_time_obj_for_cmp
          },
        };
      }

    case GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_cmps_stats_by_id: false,

      };


    //LEADS STATS
    case GET_LEAD_CAMPAIGN_STATS:
      return {
        ...state,
        loading_all_cmps_stats: true,
        loading_all_cmps_lead_stats: true,
        lead_campaign_stats_loading: true,
        last_fetch_all_cmps_stats_time_key: action.payload.time_frame_key,
        last_fetch_all_cmps_stats_custom_date_range: action.payload.time_frame_key === DATE_RANGE_OPTIONS.CUSTOM_RANGE ? action.payload.queryParams : null,
      };

    case GET_LEAD_CAMPAIGN_STATS_SUCCESS:
      let lead_cmp_stats = _.cloneDeep(state.lead_campaign_stats)
      const updatedLeadStats = action.payload?.map(cmp_stat => {
        const cmp_index = lead_cmp_stats.findIndex(lead_cmp_stat => lead_cmp_stat.id == cmp_stat.id)
        if (cmp_index == -1) {
          return cmp_stat
        } else {
          return cmp_stat = _.merge(lead_cmp_stats[cmp_index], cmp_stat)
        }
      })
      return {
        ...state,
        lead_campaign_stats: updatedLeadStats,
        last_fetch_all_cmps_stats_time_key: action.time_frame_key,
        loading_all_cmps_stats: false,
        loading_all_cmps_lead_stats: false,
        lead_campaign_stats_loading: false,
      };

    case GET_LEAD_CAMPAIGN_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loading_all_cmps_lead_stats: false,
        lead_campaign_stats_loading: false,
      };

    case GET_LEAD_CAMPAIGN_STATS_BY_ID:
      return {
        ...state,
        loading_cmps_lead_stats_by_id: true,
        lead_campaign_stats_loading: true,
      };

    case GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS:
      {
        let fetch_ad_groups = true;
        let fetch_campaign_stats = true;
        if (action.feature_flag) {
          fetch_ad_groups = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS];
          fetch_campaign_stats = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS];
        }
        const cmp_id = action.payload.id

        let fetch_time_obj_for_cmp = (state.last_fetch_cmps_stats_by_id_time_key[cmp_id.toString()] || {})
        if (fetch_ad_groups) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS] = action.time_frame_key
        }

        if (fetch_campaign_stats) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS] = action.time_frame_key
        }

        const cmp_index = state.lead_campaign_stats.findIndex(campaign_stat => campaign_stat.id == action.payload.id)
        let lead_cmp_stats = _.cloneDeep(state.lead_campaign_stats)
        if (cmp_index == -1) {
          lead_cmp_stats.push(action.payload)
        } else {
          lead_cmp_stats[cmp_index] = _.merge(lead_cmp_stats[cmp_index], action.payload)
        }

        return {
          ...state,
          lead_campaign_stats: lead_cmp_stats,
          loading_cmps_lead_stats_by_id: false,
          last_fetch_cmps_stats_by_id_time_key: {
            ...state.last_fetch_cmps_stats_by_id_time_key,
            [action.payload.id.toString()]: fetch_time_obj_for_cmp
          },
          lead_campaign_stats_loading: false,
        };
      }

    case GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_cmps_stats_by_id: false,
        lead_campaign_stats_loading: false,
      };


    //CALL STATS
    case GET_CALL_CAMPAIGN_STATS:
      return {
        ...state,
        loading_all_cmps_stats: true,
        loading_all_cmps_call_stats: true,
        call_campaign_stats_loading: true,
        last_fetch_all_cmps_stats_time_key: action.payload.time_frame_key,
        last_fetch_all_cmps_stats_custom_date_range: action.payload.time_frame_key === DATE_RANGE_OPTIONS.CUSTOM_RANGE ? action.payload.queryParams : null,
      };

    case GET_CALL_CAMPAIGN_STATS_SUCCESS:
      let call_cmp_stats = _.cloneDeep(state.call_campaign_stats)
      const updatedCallStats = action.payload.map(cmp_stat => {
        const cmp_index = call_cmp_stats.findIndex(call_cmp_stat => call_cmp_stat.id == cmp_stat.id)
        if (cmp_index == -1) {
          return cmp_stat
        } else {
          return cmp_stat = _.merge(call_cmp_stats[cmp_index], cmp_stat)
        }
      })
      return {
        ...state,
        call_campaign_stats: updatedCallStats,
        last_fetch_all_cmps_stats_time_key: action.time_frame_key,
        loading_all_cmps_stats: false,
        loading_all_cmps_call_stats: false,
        call_campaign_stats_loading: false,
      };

    case GET_CALL_CAMPAIGN_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loading_all_cmps_call_stats: false,
        call_campaign_stats_loading: false,
      };

    case GET_CALL_CAMPAIGN_STATS_BY_ID:
      return {
        ...state,
        loading_cmps_call_stats_by_id: true,
      };

    case GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS:
      {
        let fetch_ad_groups = true;
        let fetch_campaign_stats = true;
        if (action.feature_flag) {
          fetch_ad_groups = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS];
          fetch_campaign_stats = action.queryParams[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS];
        }
        const cmp_id = action.payload.id

        let fetch_time_obj_for_cmp = (state.last_fetch_cmps_stats_by_id_time_key[cmp_id.toString()] || {})
        if (fetch_ad_groups) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_AD_GROUPS] = action.time_frame_key
        }

        if (fetch_campaign_stats) {
          fetch_time_obj_for_cmp[CAMPAIGN_BY_ID_API_TYPE.FETCH_CAMPAIGN_STATS] = action.time_frame_key
        }

        const cmp_index = state.call_campaign_stats.findIndex(campaign_stat => campaign_stat.id == action.payload.id)
        let call_cmp_stats = _.cloneDeep(state.call_campaign_stats)
        if (cmp_index == -1) {
          call_cmp_stats.push(action.payload)
        } else {
          call_cmp_stats[cmp_index] = _.merge(call_cmp_stats[cmp_index], action.payload)
        }

        return {
          ...state,
          call_campaign_stats: call_cmp_stats,
          loading_cmps_call_stats_by_id: false,
          last_fetch_cmps_stats_by_id_time_key: {
            ...state.last_fetch_cmps_stats_by_id_time_key,
            [action.payload.id.toString()]: fetch_time_obj_for_cmp
          },
        };
      }

    case GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_cmps_call_stats_by_id: false,

      };
    case GET_FILTER_PACKAGES:
      return {
        ...state,
        loading_filter_packages: true,
      };
    case GET_FILTER_PACKAGES_SUCCESS:
      return {
        ...state,
        filter_packages: action.payload,
        loading_filter_packages: false,
      };
    case GET_FILTER_PACKAGES_ERROR:
      return {
        ...state,
        filter_packages_error: action.payload,
        loading_filter_packages: false,
      };

    case GET_CAMPAIGNS_SOURCE_SETTINGS:
      return {
        ...state,
        loading: true,
      };

    case GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS:
      {
        const cmp_id = action.campaign_id
        const cmp_index = state.campaigns.findIndex(campaign => campaign.id == cmp_id)
        let campaigns = _.cloneDeep(state.campaigns)
        if (cmp_index !== -1) {
          campaigns[cmp_index] = { ...campaigns[cmp_index], campaign_source_settings: action.payload }
        }
        return {
          ...state,
          campaigns: campaigns,
          loading: false,
        };
      }

    case GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_ACTIVE_CAMPAIGNS_FOR_SOURCES:
      return {
        ...state,
        active_campaigns_for_sources: [],
        active_campaigns_for_sources_loading: true,
      };
    case GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS:
      return {
        ...state,
        active_campaigns_for_sources: action.payload,
        active_campaigns_for_sources_loading: false,
      };
    case GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR:
      return {
        ...state,
        active_campaigns_for_sources: [],
        active_campaigns_for_sources_loading: false,
      };

    case GET_DEFAULT_TRANSFER_NUMBER:
      return {
        ...state,
        default_transfer_number_loading: true,
        default_transfer_number: null,
        default_transfer_number_error: null
      };

    case GET_DEFAULT_TRANSFER_NUMBER_SUCCESS:
      return {
        ...state,
        default_transfer_number_loading: false,
        default_transfer_number: action.payload?.transfer_number || null,
        default_transfer_number_error: null
      };

    case GET_DEFAULT_TRANSFER_NUMBER_ERROR:
      return {
        ...state,
        default_transfer_number_loading: false,
        default_transfer_number: null,
        default_transfer_number_error: action.payload
      };

    case SET_PREVIOUS_LEAD_TYPE_ID:
      return {
        ...state,
        previous_lead_type_id: action.payload
      };

    case GET_AD_GROUP_STATS_V4:
      return {
        ...state,
        ad_group_stats_v4_loading: true,
        ad_group_stats_v4_error: null
      };

    case GET_AD_GROUP_STATS_V4_SUCCESS:
      return {
        ...state,
        ad_group_stats_v4: action.payload,
        ad_group_stats_v4_loading: false,
        ad_group_stats_v4_error: null
      };

    case GET_AD_GROUP_STATS_V4_ERROR:
      return {
        ...state,
        ad_group_stats_v4: [],
        ad_group_stats_v4_loading: false,
        ad_group_stats_v4_error: action.payload
      };

    case GET_BID_MULTIPLIER_HISTORY:
      return {
        ...state,
        bid_multiplier_history: [],
        bid_multiplier_history_loading: true,
      };

    case GET_BID_MULTIPLIER_HISTORY_SUCCESS:
      return {
        ...state,
        bid_multiplier_history: action.payload,
        bid_multiplier_history_loading: false,
        lastCompletedAction: action.type,
        error: null,
      };

    case GET_BID_MULTIPLIER_HISTORY_ERROR:
      return {
        ...state,
        bid_multiplier_history_loading: false,
        error: action.error,
      };
    case GET_AD_GROUP_BID_MULTIPLIER_HISTORY:
      return {
        ...state,
        ad_group_bid_multiplier_history: [],
        ad_group_bid_multiplier_history_loading: true,
        ad_group_bid_multiplier_history_error: null,
      };

    case GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS:
      return {
        ...state,
        ad_group_bid_multiplier_history: action.payload,
        ad_group_bid_multiplier_history_loading: false,
        ad_group_bid_multiplier_history_error: null,
      };

    case GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR:
      return {
        ...state,
        ad_group_bid_multiplier_history: [],
        ad_group_bid_multiplier_history_loading: false,
        ad_group_bid_multiplier_history_error: action.error,
      };

    default:
      return state;
  }
};

export default campaigns;
